<template>
  <v-app>

    <headerBar />
    <!-- Sizes your content based upon application components -->

    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container fluid fill-height>
        <v-row justify="center" align="center">
          <v-col
            cols="12"
           
            md="8"
           
            class="m-10"
          >
            <paymentCard />
          </v-col>
        </v-row>

        <!-- If using vue-router -->
        <!-- <router-view></router-view> -->
      </v-container>
    </v-main>

    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>
import paymentCard from "./components/paymentCard";
import headerBar from "./components/headerBar";
export default {
  components: {
    paymentCard,
    headerBar
  },
  methods: {
    closeError() {
      this.$store.dispatch("clearError");
    },
    closeNotification() {
      this.$store.dispatch("clearNotification");
    },
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
  },
};
</script>
<style lang="scss">
</style>
